module.exports = __webpack_public_path__ + "static/media/plank.87d12731.jpg";